import { isFulfilled, isPending, isRejected } from "./reducerUtils";
let initialState = {
    ruleList: [],
    ruleListLoading: false,
    syncSF: 0,
};

const SMRRuleReducer = (state = initialState, action) => {
    switch (action.type) {
        case isPending("FETCH_RULES_LIST"):
            return (state = {
                ...state,
                ruleListLoading: true,
                ruleList: [],
            });
        case isRejected("FETCH_RULES_LIST"):
            return (state = {
                ...state,
                ruleListLoading: false,
                ruleList: [],
            });
        case isFulfilled("FETCH_RULES_LIST"): {
            // console.log("hello heree action", action.payload);
            return (state = {
                ...state,
                ruleListLoading: false,
                ruleList: action.payload,
                // .templates.sort(function (a, b) {
                //     return new Date(b.created_at) - new Date(a.created_at);
                // }) || [],
            });
        }

        case isFulfilled("FETCH_SALESFORCE"): {
            // console.log("hello", action.payload);
            return (state = {
                ...state,
                ruleListLoading: false,
                syncSF: action.payload.data.settings.salesforce_sync_enabled,
                // ruleList: action.payload,
                // .templates.sort(function (a, b) {
                //     return new Date(b.created_at) - new Date(a.created_at);
                // }) || [],
            });
        }

        case "UPDATE_RULES":
            return (state = {
                ...state,
                ruleListLoading: false,
                ruleList: action.payload || [],
            });

        default:
            return state;
    }
};
export default SMRRuleReducer;
